import React from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { Grid } from '@material-ui/core/index';

import Button from 'src/components/Button';
import useModal from 'src/components/Modal/useModal';
import { WorkflowWithStepsAndEdges } from 'src/types';
import useGetRequest from 'src/hooks/useGetRequest';
import Content from 'src/components/Content';
import WorkflowCard from './WorkflowCard';
import WorkflowModal from './WorkflowModal';
import Loader from '../../../components/Loader';
import EmptyState from '../../../components/EmptyState';

function WorkflowsCardList() {
  const history = useHistory();
  const { isOpen, openModal, closeModal } = useModal();

  const { result: workflows, isLoading } = useGetRequest({
    url: '/automatic/workflows/',
    initialResult: [],
  });

  const actions = (
    <Button look="primary" onClick={openModal}>
      Create workflow
    </Button>
  );

  let content;
  if (isLoading) {
    content = <Loader />;
  } else if (!workflows.length) {
    content = <EmptyState text="No workflows found.">{actions}</EmptyState>;
  } else {
    content = workflows.map((workflow: WorkflowWithStepsAndEdges) => <Grid item xs={12} md={3}><WorkflowCard workflow={workflow} /></Grid>);
  }

  return (
    <Content title="Workflows" maxWidth="lg" actions={workflows.length ? actions : null}>
      {isOpen && <WorkflowModal isOpen={isOpen} onClose={closeModal} onSuccess={(res: any) => history.push(`/workflows/${res.id}/process`)} />}
      <Grid container spacing={3}>
        {content}
      </Grid>
    </Content>
  );
}

export default WorkflowsCardList;
